import { render, staticRenderFns } from "./ProgramLevelSelectbox.vue?vue&type=template&id=2be2eaa6&"
import script from "./ProgramLevelSelectbox.vue?vue&type=script&lang=js&"
export * from "./ProgramLevelSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports